"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitMeterReadMutation = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var mapping_1 = require("./mapping");
var reads_caching_1 = require("./mapping/reads-caching");
var useUpdateReadCache_1 = require("./useUpdateReadCache");
var useSubmitMeterReadMutation = function (_a) {
    var accountId = _a.accountId, sprn = _a.sprn, fuel = _a.fuel;
    var _b = __read((0, kapi_1.useSubmitElectricityMeterReadMutation)({
        refetchQueries: [kapi_1.ApMeterReadsDocument],
        awaitRefetchQueries: true,
    }), 2), kapiElecMutation = _b[0], kapiElecLoading = _b[1].loading;
    var _c = __read((0, kapi_1.useSubmitGasMeterReadMutation)({
        refetchQueries: [kapi_1.ApMeterReadsDocument],
        awaitRefetchQueries: true,
    }), 2), kapiGasMutation = _c[0], kapiGasLoading = _c[1].loading;
    var updateReadCache = (0, useUpdateReadCache_1.useUpdateReadCache)(accountId, sprn);
    var handleKapiMutation = function (data, _a) {
        var _b = _a === void 0 ? {} : _a, onCompleted = _b.onCompleted, onError = _b.onError;
        var handleError = function (error) {
            return onError === null || onError === void 0 ? void 0 : onError((0, mapping_1.mapKapiErrorResponseToSubmitReadError)(error));
        };
        switch (data.fuel) {
            case 'electricity':
                return kapiElecMutation({
                    variables: {
                        input: (0, mapping_1.mapSubmitReadCXToKapiElectricity)(data),
                    },
                    onCompleted: function (submitResponse) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            updateReadCache((0, reads_caching_1.createCacheableElecRead)((_a = submitResponse.submitElectricityMeterRead_nextV1) === null || _a === void 0 ? void 0 : _a.id, data));
                            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted();
                            return [2 /*return*/];
                        });
                    }); },
                    onError: handleError,
                });
            case 'gas':
                return kapiGasMutation({
                    variables: {
                        input: (0, mapping_1.mapSubmitReadCXToKapiGas)(data),
                    },
                    onCompleted: function (submitResponse) {
                        var _a;
                        updateReadCache((0, reads_caching_1.createCacheableGasRead)((_a = submitResponse.submitGasMeterRead_nextV1) === null || _a === void 0 ? void 0 : _a.id, data));
                        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted();
                    },
                    onError: handleError,
                });
        }
    };
    var kapiLoading = fuel === 'electricity' ? kapiElecLoading : kapiGasLoading;
    return {
        mutate: handleKapiMutation,
        loading: kapiLoading,
    };
};
exports.useSubmitMeterReadMutation = useSubmitMeterReadMutation;
